import { ItemList } from '../orm'

class IncomingFaxByEmailSettingsList extends ItemList {
    getEntityKey() {
        return "incoming_fax_by_email_settings"
    }
}

export const incomingFaxByEmailSettingsList = new IncomingFaxByEmailSettingsList("incoming_fax_by_email_settings__default")
